<template>
  <v-layout row wrap>
    <v-flex v-for="(field, index) in scheme"
      :key="index"
      :grow="field.grow || false"
      :shrink="field.shrink || false"
      :xs2="checkSize(field, 'xs2')"
      :xs4="checkSize(field, 'xs4')"
      :xs6="checkSize(field, 'xs6')"
      :xs8="checkSize(field, 'xs8')"
      :xs10="checkSize(field, 'xs10')"
      :xs12="checkSize(field, 'xs12')"
      :sm2="checkSize(field, 'sm2')"
      :sm4="checkSize(field, 'sm4')"
      :sm6="checkSize(field, 'sm6')"
      :sm8="checkSize(field, 'sm8')"
      :sm10="checkSize(field, 'sm10')"
      :sm12="checkSize(field, 'sm12')"
      pa-1
      v-if="checkIf(field)"
    >
      <component
                 :is="field.fieldType"
                 :tabindex="calcTabIndex(field)"
                 :value="formData[field.name]"
                 @input="updateForm(field, $event)"
                 @change="formatForm(field, $event)"
                 v-bind="field"
                 v-on="field.events || {}"
                 :hint="calcHint(field)"
                 :error-messages="calcErrors(field)"
                 :items="calcItems(field)"
                 :emptyChip="calcEmptyChip(field)"
                 :disabled="checkDisabled(field)"
                 :ref="checkFocused(field)"
                 >
                 <span v-html="calcSlot(field)"></span>
      </component>
    </v-flex>
  </v-layout>
</template>

<script>
import vDateField from '../common/DateField.vue'
import vSelectRadio from '../common/SelectRadio.vue'
import vSelectCheck from '../common/SelectCheck.vue'
import vChipsField from '../common/ChipsField.vue'
import vFlexField from '../common/FlexField.vue'
import vHtmlField from '../common/HtmlField.vue'
import vMacroField from '../common/MacroField.vue'
import vItemsField from '../common/ItemsField.vue'

export default {
  name: 'step-generator',
  components: {vDateField, vSelectRadio, vSelectCheck, vFlexField, vChipsField, vHtmlField, vMacroField, vItemsField},
  props: ['scheme', 'value'],
  data () {
    return {
      formData: this.value || {}
    }
  },
  watch: {
    value (newValue, oldValue) {
      this.formData = newValue
    }
  },
  mounted () {
    this.$nextTick(function () {
      let input = this.$refs.focused && this.$refs.focused.length > 0 && this.$refs.focused[0].$el || this.$el
      input = input.querySelector('input')
      input && input.focus()
    })
  },
  methods: {
    updateForm (field, value) {
      if (field) {
        this.$set(this.formData, field.name, value)
        this.$emit('input', this.formData)
      }
    },
    formatForm (field, value) {
      if (field && field.format) {
        value = field.format(value)
        this.$set(this.formData, field.name, value)
      }
    },
    checkSize (field, size) {
      return (field && field.size && field.size[size]) || false
    },
    checkIf (field) {
      if (!field.if) {
        return true
      }
      return field.if(this.formData, field)
    },
    // define field which willbe focused after mounting
    checkFocused (field) {
      if (!field.focus) {
        return null
      }
      return 'focused'
    },
    checkDisabled (field) {
      if (field.disabled === null) {
        return null
      }
      if ((typeof field.disabled) === 'function') {
        return field.disabled(this.formData, field)
      }
      return field.disabled
    },
    calcTabIndex (field) {
      return field.tabindex || 1
    },
    calcHint (field) {
      if (!field.hint) {
        return null
      }
      if ((typeof field.hint) === 'function') {
        return field.hint(this.formData, field)
      }
      return field.hint
    },
    calcErrors (field) {
      if (!field.errors) {
        return null
      }
      if ((typeof field.errors) === 'function') {
        return field.errors(this.formData, field)
      }
      return field.errors
    },
    calcSlot (field) {
      if (!field.slot) {
        return null
      }
      if ((typeof field.slot) === 'function') {
        return field.slot(this.formData, field)
      }
      return field.slot
    },
    calcItems (field) {
      if (!field.items) {
        return null
      }
      if ((typeof field.items) === 'function') {
        return field.items(this.formData, field)
      }
      return field.items
    },
    calcEmptyChip (field) {
      if (!field.emptyChip) {
        return null
      }
      if ((typeof field.emptyChip) === 'function') {
        return field.emptyChip(this.formData, field)
      }
      return field.emptyChip
    }
  }
}
</script>



// WEBPACK FOOTER //
// StepGenerator.vue?1c987b24